// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-tmp_footer__36jV7","container":"footer-tmp_container__1HqzV"};